<div [class.has-error]="!ctrl.valid && ctrl.touched || (useGroupValidation && showError()) && !form.valid && form.touched"> 
    <ng-content></ng-content>
    <kms-admin-control-messages *ngIf="!ctrl.disabled && ctrl.touched" [control]="ctrl" [group]="form" [visibleGroupErrors]="visibleGroupErrors"></kms-admin-control-messages>
</div>